import packageJson from "../../package.json";

export let customSettings = {
  captchaOn: window._env_.CAPTCHA_SHOW || false,
  captchaKey:
    window._env_.REACT_APP_CAPTCHA_KEY ||
    process.env.REACT_APP_SECRET_KEY_CAPTCHA,
  showCostCenter: window._env_.SHOW_COST_CENTER,
  showFiscalYear: window._env_.SHOW_FISCAL_YEAR,
  toastPosition: "top-right",
  toastClose: 5000,
  currencySign: "€",
  appName: "Nexusware",
};

export let PLANS = {
  BASE: "Basic",
  PREMIUM: "Premium (-10% Soldes)",
  ULTIMATE: "Ultimate (-20% Soldes)",
};

// export const BASEURL = "https://api.mp.integratorsx.com";
export const BASEURL =
  window._env_.REACT_APP_API_BASE_URL || process.env.REACT_APP_URL;

export function AppVersion() {
  return (
    <div style={{ fontWeight: "normal", fontSize: "13px" }}>
      <span>version </span>
      <span title={process.env.REACT_APP_VERSION}>{packageJson.version}</span>
    </div>
  );
}

export function Certificate() {
  const currentYear = new Date().getFullYear();
  return (
    <div style={{ fontWeight: "normal", fontSize: "13px" }}>
      <span>© {currentYear} IntegratorZ</span>
    </div>
  );
}
